export default "__VITE_ASSET__BIpYGTHy__"